var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",style:(_vm.customStyle),attrs:{"src":_vm.coverImgUrl,"draggable":false,"alt":""},on:{"click":function($event){return _vm.goHome()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }